module.exports = __webpack_public_path__ + "static/media/efix_logo.de8b1ea8.png";